import { texts } from '../translations/translation';
import useLanguage from './useLanguage';

export default function useTranslation() {
	const { language } = useLanguage();

	return texts[language];
}
